import React from 'react'
import { useMediaQuery } from 'react-responsive'
import s from './styles/SelectionBar.module.scss'
import { ReactComponent as TrashIcon } from 'assets/icons/trash-2.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'

const mapOfIcons = {
	message: <MessageIcon />,
	plus: <PlusIcon />,
	dock: <DockIcon />,
	clock: <ClockIcon />,
}

export const SelectionBar = ({
	isVisible = false,
	isOffset = false,
	text = '',
	onClear,
	onClose,
	actions = [],
	className = '',
	variant = 'default',
}) => {
	const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
	if (!isVisible) return null

	const variantClass = variant === 'soft' ? s.soft : ''

	return (
		<div
			className={`${s.wrap} ${isOffset ? s.offset : ''} ${variantClass} ${className}`.trim()}
		>
			<div className={s.inner}>
				<div className={s.content}>
					<span className={s.text}>{text}</span>

					{typeof onClear === 'function' && (
						<button type="button" className={s.clearBtn} onClick={onClear}>
							{isMobile && (
								<span className={s.clearBtn__icon}>
									<TrashIcon />
								</span>
							)}
							<span className={s.clearBtn__text}>
								{isMobile ? 'Clear' : 'Clear selection'}
							</span>
						</button>
					)}
				</div>

				<div className={s.actions}>
					{actions.map(a => (
						<button
							key={String(a.id)}
							type="button"
							ref={a.buttonRef}
							className={`${s.action} ${
								a.variant === 'secondary' ? s.secondary : ''
							}`.trim()}
							onClick={a.onClick}
							disabled={a.disabled}
							title={a.title}
							aria-label={a.ariaLabel}
						>
							{a?.icon ? (
								<span className={s.action__icon}>{a.icon}</span>
							) : !!mapOfIcons[a?.iconName] ? (
								<span className={s.action__icon}>{mapOfIcons[a.iconName]}</span>
							) : null}
							<span className={s.action__text}>{a.label}</span>
						</button>
					))}

					{typeof onClose === 'function' && (
						<button
							type="button"
							className={s.closeBtn}
							onClick={onClose}
							aria-label="Close selection"
						>
							<span className="material-icons">close</span>
						</button>
					)}
				</div>
			</div>
		</div>
	)
}
